import { postData } from "../pages/Utils/Baseurl";

export const getProjectsMiddleware = async (user_id) => {
  if (!user_id) {
    throw new Error("user_id is required");
  }

  return await postData("api/getProject/", {
    user_id: user_id,
  });
};



